import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-link-expired',
  templateUrl: './link-expired.component.html',
})
export class LinkExpiredComponent implements OnInit {
  linkText: any;
  language: any;
  constructor(private commonService: CommonService, private router: Router) { }

  ngOnInit(): void {
    this.language = localStorage.getItem('selectedLang');
    this.commonService.getLimit.subscribe(l => {
      if (l) {
        this.linkText = l;
      } else {
        this.router.navigateByUrl('/home')
      }
    })

  }


}
